import { useRegisterWithInvite } from '../../model'
import { Fieldset } from '@/common/ui/Form/Fieldset/Fieldset'
import { Input, InputPassword } from '@/common/ui/Form'
import { Button } from '@/common/ui/Form/Button'
import { Checkbox } from '@/common/ui/Form/Checkbox'
import { PASSWORD_VALIDATION } from '@/common/ui/Form/Input'

export type RegisterWithInviteProps = {
    email: string
    inviteToken: string
}

export const RegistrationFormWithInvite = ({ email, inviteToken }: RegisterWithInviteProps) => {
    const { register, handleSubmit, errors, onSubmit, mutation } = useRegisterWithInvite({ inviteToken })

    return (
        <form
            onSubmit={handleSubmit(onSubmit)}
            aria-label='Форма регистрации'
            className='w-full flex flex-col gap-[1.875rem]'
        >
            <div>
                <Fieldset required>
                    <Input
                        size='lg'
                        aria-label='Email'
                        type='text'
                        placeholder='Email'
                        className='w-full'
                        disabled
                        value={email}
                    />
                </Fieldset>
            </div>
            <div>
                <Fieldset errorText={errors.password?.message} required>
                    <InputPassword
                        size='lg'
                        placeholder='Пароль'
                        className='w-full'
                        aria-label='Пароль'
                        autoComplete='off'
                        {...register('password', { required: PASSWORD_VALIDATION.required })}
                    />
                </Fieldset>
            </div>
            <div>
                <Fieldset errorText={errors.password_confirm?.message} required>
                    <InputPassword
                        size='lg'
                        placeholder='Подтвердите пароль'
                        className='w-full'
                        aria-label='Подтвердите пароль'
                        autoComplete='off'
                        {...register('password_confirm', { required: PASSWORD_VALIDATION.required })}
                    />
                </Fieldset>
            </div>
            <div>
                <Fieldset>
                    <Checkbox
                        id='subscribe-marketing-invite'
                        aria-label='Согласие на рассылки'
                        {...register('subscribe_marketing')}
                    />
                    <label htmlFor='subscribe-marketing-invite' className='ml-2'>
                        Согласен получать рекламные и информационные рассылки
                    </label>
                </Fieldset>
            </div>
            <div>
                <Fieldset errorText={errors.terms_of_service?.message} required>
                    <Checkbox
                        id='terms-of-service'
                        {...register('terms_of_service', {
                            required: 'Необходимо согласиться с условиями пользовательского соглашения',
                        })}
                    />
                    <label htmlFor='terms-of-service' className='ml-2'>
                        Согласен с условиями{' '}
                        <a href='/eula.pdf' target='_blank' className='underline whitespace-nowrap'>
                            публичной оферты
                        </a>{' '}
                        и подтверждаю свое согласие с{' '}
                        <a href='/privacy.pdf' target='_blank' className='underline'>
                            политикой в отношении обработки персональных данных
                        </a>
                        .
                    </label>
                </Fieldset>
            </div>

            {errors.root && <div className='input-error text-center text-sm text-error'>{errors.root.message}</div>}
            <Button
                variant='filled'
                emphasis='accent'
                size='xl'
                className='w-full'
                type='submit'
                aria-label='Зарегистрироваться'
                disabled={mutation.isPending}
                loading={mutation.isPending}
            >
                Зарегистрироваться и принять
            </Button>
        </form>
    )
}
